import { Select } from 'antd';
import { ArrowDown, ArrowUp } from 'assets/images';
import { useState } from 'react';
import PropTypes from 'prop-types';
import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';

export const BaseSelect = ({ children, useCaretIcon, className, ...rest }) => {
  const [visibleLanguageSelection, setVisibleLanguageSelection] =
    useState(false);

  const onDropdownVisibleChange = (open) => {
    setVisibleLanguageSelection(open);
  };

  const UpIconNode = useCaretIcon ? CaretUpFilled : ArrowUp;
  const DownIconNode = useCaretIcon ? CaretDownFilled : ArrowDown;

  const baseSelectClassName = ['base-select', className].join(' ');

  return (
    <Select
      className={baseSelectClassName}
      suffixIcon={visibleLanguageSelection ? <UpIconNode /> : <DownIconNode />}
      onDropdownVisibleChange={onDropdownVisibleChange}
      {...rest}>
      {children}
    </Select>
  );
};

BaseSelect.Option = Select.Option;
BaseSelect.OptGroup = Select.OptGroup;

BaseSelect.defaultProps = {
  children: undefined,
  useCaretIcon: false,
  className: ''
};

BaseSelect.propTypes = {
  useCaretIcon: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};
